import './SectionHeader.scss'

export interface ISectionHeader {
  title: string
  description: string
  inLine?: boolean
  maxWidth: string
}

export const SectionHeader = ({
  title,
  description,
  inLine = false,
  maxWidth,
}: ISectionHeader) => {
  return (
    <div
      className="descriptionInfo"
      style={
        inLine
          ? { display: 'flex', justifyContent: 'space-between', maxWidth }
          : { maxWidth }
      }
    >
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  )
}
